<template>
    <div class="netdisk-container">
        <van-uploader :after-read="afterRead" accept="*"/>

    </div>
</template>

<script>
export default {
    methods: {
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
            let _self = this;
            let formData = new FormData();// 需要将前端的File对象转换为传输给后端的FormData对象
            formData.append('file', file.file);
            formData.append("currentFolderId", "1801168673970421760");
            _self.$api.netdisk
                .upload(formData)
                .then(
                    res => {
                        if (res.returnCode === 200) {
                            _self.$toast.success("上传成功");
                        } else {
                            _self.$toast.fail(res.returnMsg);
                        }
                    },
                    error => {
                        console.log(error);
                        _self.$toast.fail("服务器忙，请稍后重试");
                    }
                )
                .catch(err => {
                    console.log(err);
                });
        },
    },

}
</script>

<style scoped></style>